import { api } from './client'
import type { LoginRequest, LoginResponse, RefreshResponse, Sesion, Usuario } from '@/types/api'

export const authApi = {
  login: (payload: LoginRequest) =>
    api.post<LoginResponse>('/auth/login', payload).then((r) => r.data),

  refresh: () => api.post<RefreshResponse>('/auth/refresh').then((r) => r.data),

  logout: () => api.post<{ message: string }>('/auth/logout').then((r) => r.data),

  logoutAll: () => api.post<{ message: string }>('/auth/logout-all').then((r) => r.data),

  me: () => api.get<Usuario>('/auth/me').then((r) => r.data),

  olvide: (email: string) =>
    api.post<{ message: string }>('/auth/olvide', { email }).then((r) => r.data),

  restablecer: (token: string, password: string) =>
    api.post<{ message: string }>('/auth/restablecer', { token, password }).then((r) => r.data),

  sesiones: () => api.get<Sesion[]>('/auth/sesiones').then((r) => r.data),

  cerrarSesion: (id: number) =>
    api.delete<{ message: string }>(`/auth/sesiones/${id}`).then((r) => r.data),

  changePassword: (password_actual: string, password_nueva: string) =>
    api
      .post<{ message: string }>('/auth/change-password', { password_actual, password_nueva })
      .then((r) => r.data),
}
